// Styles
import styles from './group-hero.module.scss'

interface GroupHeroProps {
  image: string
  title: string
}

const GroupHero = ({
  image,
  title,
}: GroupHeroProps) => {
  return (
    <div
      className={styles['group-hero']}
      style={{backgroundImage: `url(${image})`}}
    >
      <span className={styles['__title']}>{title}</span>
    </div>
  )
}

export default GroupHero
